import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import auth from './auth'
import rim from './rim'
import tyres from './tyres'
import motoTyre from './moto-tyre'
import search from './search'
import motoSearch from './moto-search'
import news from './news'
import appModules from './app-modules'
import tyreFamilies from './tyre-families'
import tyreFamiliesMotorcycles from './tyre-families-motorcycles'
import userSessions from './user-sessions'
import dealers from './dealers'
import users from './users'
import carMeasures from './car-measures'
import motoMeasures from './moto-measures'
import b2bOn from './b2b-on'
import b2bOff from './b2b-off'
import motorcycles from './motorcycles'
import tyreFamilyMeasures from './tyre-family-measures'
import technologies from './technologies'
import bike from './bike'
import verifyAccount from './verify-account'
import courses from './courses'
import frequentQuestions from './frequent-questions'
import courseFiles from './course-files'
import courseTags from './course-tags'
import submissions from './submissions'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default new Vuex.Store({
  modules: {
    app,
    auth,
    rim,
    tyres,
    motoTyre,
    search,
    motoSearch,
    news,
    appModules,
    tyreFamilies,
    tyreFamiliesMotorcycles,
    'user-sessions': userSessions,
    dealers,
    users,
    'car-measures': carMeasures,
    'moto-measures': motoMeasures,
    'b2b-on': b2bOn,
    'b2b-off': b2bOff,
    motorcycles,
    'tyre-family-measures': tyreFamilyMeasures,
    technologies,
    bike,
    'verify-account': verifyAccount,
    courses,
    'frequent-questions': frequentQuestions,
    'course-files': courseFiles,
    'course-tags': courseTags,
    submissions
  },

  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV
})
